export default () => ({
  checkouts: [],
  currentCheckout: {},
  existingPatient: null,
  cart: [],
  action: null,
  paymentMethod: null,
  paymentResult: null,
})
